module.exports = __webpack_public_path__ + "img/satisfaction-bg.256100f4.png";